import { connectedStore } from '../../../store';
import site from '../../../site';

const setupBaseURL = (liveDOM) => {
  const store = connectedStore.get();
  const state = store.getState();

  const base = liveDOM.createElement('base');
  base.href = site.selectors.getAssetsUrl(state);
  liveDOM.head.insertAdjacentElement('afterbegin', base);
};

export default setupBaseURL;
